import React from "react";

export const DEFAULT_PAGE_SIZE = 15;
export const PAGE_SIZE_OPTIONS = [10, 15, 25, 50];

export function slicePage(rows, page, pageSize) {
  const totalPages = Math.max(1, Math.ceil(rows.length / pageSize));
  const safePage = Math.min(Math.max(1, page), totalPages);
  const start = (safePage - 1) * pageSize;
  return {
    pageRows: rows.slice(start, start + pageSize),
    totalPages,
    page: safePage,
    totalItems: rows.length,
  };
}

export function PgTablePagination({
  page,
  totalPages,
  totalItems,
  pageSize,
  onPageSizeChange,
  onPageChange,
}) {
  return (
    <div className="pg-pagination" aria-label="Table pagination">
      <span className="pg-pagination__label">Page Size:</span>
      <select
        className="pg-pagination__size"
        value={pageSize}
        onChange={(e) => onPageSizeChange(Number(e.target.value))}
        aria-label="Rows per page"
      >
        {PAGE_SIZE_OPTIONS.map((n) => (
          <option key={n} value={n}>{n}</option>
        ))}
      </select>
      <span className="pg-pagination__count">{totalItems} items</span>
      <button
        type="button"
        className="pg-pagination__nav"
        disabled={page <= 1}
        onClick={() => onPageChange(1)}
        aria-label="First page"
      >
        ⏮
      </button>
      <button
        type="button"
        className="pg-pagination__nav"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
        aria-label="Previous page"
      >
        ‹
      </button>
      <span className="pg-pagination__page">Page {page} of {totalPages}</span>
      <button
        type="button"
        className="pg-pagination__nav"
        disabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}
        aria-label="Next page"
      >
        ›
      </button>
      <button
        type="button"
        className="pg-pagination__nav"
        disabled={page >= totalPages}
        onClick={() => onPageChange(totalPages)}
        aria-label="Last page"
      >
        ⏭
      </button>
    </div>
  );
}
